import React from "react";
import { useTranslation } from "react-i18next";
import {
  useEditStrategicAxis,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { StrategicAxis } from "@planzone/dto";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function StrategicAxisEdition({ cancel, strategicAxis }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, editStrategicAxis } =
    useEditStrategicAxis(strategicAxis);
  const [formData, setFormData] = React.useState<StrategicAxis>(strategicAxis);

  return (
    <Modal header={t("strategicAxesPage.edition.title")} close={cancel}>
      <form
        className={styles.strategicAxisEdition}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending &&
            editStrategicAxis({
              planzone,
              strategicAxis,
              nextStrategicAxis: formData,
            });
        }}
      >
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("strategicAxesPage.edition.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("strategicAxesPage.edition.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { StrategicAxisEdition };
